import { render, staticRenderFns } from "./datosPlan.vue?vue&type=template&id=9a9482fe"
import script from "./datosPlan.vue?vue&type=script&lang=js"
export * from "./datosPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports